export default __webpack_public_path__ + "static/media/mobile-footer.90d656bf.png";